import NewTabLink from 'components/next/NewTabLink';
import ProfileEditableTable from 'pages/profile/components/ProfileTabContent/components/ProfileEditableTable';
import ProfileSection from 'pages/profile/components/ProfileTabContent/components/ProfileSection';
import ExternalLinkIcon from 'public/assets/icons/external_link.svg';
import useUserDetails from '../../../../../hooks/requests/user/hooks/useUserDetails';

const HELP_CENTER_LINK = 'https://landa.app/help-center';
const RESIDENT_HELP_CENTER_LINK = 'https://www.landa.app/resident-help-center';
const EDUCATION_CENTER_LINK = 'https://landa.app/real-estate-blocks';

const HelpAndSupport = () => {
  const { userDetails } = useUserDetails();
  const data = userDetails?.isTenant
    ? [
        {
          key: 'Help Center',
          value: (
            <NewTabLink to={RESIDENT_HELP_CENTER_LINK}>
              <ExternalLinkIcon />
            </NewTabLink>
          ),
        },
      ]
    : [
        {
          key: 'Help Center',
          value: (
            <NewTabLink to={HELP_CENTER_LINK}>
              <ExternalLinkIcon />
            </NewTabLink>
          ),
        },
        {
          key: 'Education Center',
          value: (
            <NewTabLink to={EDUCATION_CENTER_LINK}>
              <ExternalLinkIcon />
            </NewTabLink>
          ),
        },
      ];
  return (
    <ProfileSection title={'Landa Support'}>
      <ProfileEditableTable data={data} />
    </ProfileSection>
  );
};

export default HelpAndSupport;
